module.exports = __webpack_public_path__ + "static/media/rip.1835df5e.svg";